// extracted by mini-css-extract-plugin
module.exports = {"brands":"style_brands__RzAXR","column":"style_column__U9ol1"};